import { ExtensionInfo } from 'hooks/embedded-status/useEmbeddedStatusSwr';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
    goToThemesEditor,
    SMART_DELIVERY_PAGE_APP_EMBED_BLOCK_HANDLE,
} from '../../../../../../../utils/app-embed/appsEmbedIntegrationUtils';
import { SettingsWrapper } from '../../settings-wrapper/SettingsWrapper';
import { findThemeAppExtension, hasSmartDeliveryPageEmbedBlock } from '../integrationStatusUtils';

// Status of the Smart Delivery Page integration's theme app embed — same shape as the cart map's
// `AppsEmbedIntegration`, for the `pickupbird-smart-delivery-page-embed-block` embed
export const SmartDeliveryPageIntegration = ({
    extensions,
    isLoading,
    condensed,
    handleClickAddStoreAppBlock,
}: SmartDeliveryPageIntegrationProps) => {
    const { t } = useTranslation();

    const isActive = useMemo(() => hasSmartDeliveryPageEmbedBlock(findThemeAppExtension(extensions)), [extensions]);

    const openAppEmbedSettings = () => {
        open(`shopify://admin/themes/current/editor?context=apps&template=index`, '_blank');
    };

    const handleAddAppEmbed = () => {
        handleClickAddStoreAppBlock?.();
        goToThemesEditor(SMART_DELIVERY_PAGE_APP_EMBED_BLOCK_HANDLE);
    };

    return (
        <SettingsWrapper
            title={t('DASHBOARD.APP_EXTENSIONS.SMART_DELIVERY_PAGE_EMBED_INTEGRATION.TITLE')}
            badge={
                <s-badge tone={isActive ? 'success' : undefined}>
                    {isActive ? t('DASHBOARD.APP_EXTENSIONS.ACTIVE') : t('DASHBOARD.APP_EXTENSIONS.INACTIVE')}
                </s-badge>
            }
            description={
                isActive
                    ? t('DASHBOARD.APP_EXTENSIONS.SMART_DELIVERY_PAGE_EMBED_INTEGRATION.ACTIVE')
                    : t('DASHBOARD.APP_EXTENSIONS.SMART_DELIVERY_PAGE_EMBED_INTEGRATION.INACTIVE')
            }
            actions={
                <s-button variant="secondary" onClick={isActive ? openAppEmbedSettings : handleAddAppEmbed}>
                    {isActive
                        ? t('DASHBOARD.APP_EXTENSIONS.SMART_DELIVERY_PAGE_EMBED_INTEGRATION.ACTIONS.APP_EMBED_SETTINGS')
                        : t('DASHBOARD.APP_EXTENSIONS.SMART_DELIVERY_PAGE_EMBED_INTEGRATION.ACTIONS.ADD_EMBED_APP')}
                </s-button>
            }
            notificationBanner={
                isActive ? null : (
                    <s-banner tone="warning">
                        {t('DASHBOARD.APP_EXTENSIONS.SMART_DELIVERY_PAGE_EMBED_INTEGRATION.INACTIVE_DESCRIPTION')}
                    </s-banner>
                )
            }
            isLoading={isLoading}
            condensed={condensed}
        />
    );
};

interface SmartDeliveryPageIntegrationProps {
    extensions: ExtensionInfo[];
    isLoading: boolean;
    condensed?: boolean;
    handleClickAddStoreAppBlock?: () => void;
}
